//
// MissingValueCheckboxLocationType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var MissingValueCheckboxLocationType = {
    NONE:0,
    RIGHT:1,
    BOTTOM:2
};
export default MissingValueCheckboxLocationType;
